import { useEffect, useState } from "react";
import { filePreviewUrl } from "@/lib/api";
import { FileIcon } from "@/components/FileIcon";
import { Skeleton } from "@/components/ui/skeleton";

export function FilePreview({ file }) {
  const url = filePreviewUrl(file.public_id);
  const [text, setText] = useState(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    if (file.preview_kind !== "text") return;
    fetch(url, { credentials: "include" })
      .then((r) => (r.ok ? r.text() : Promise.reject()))
      .then((t) => setText(t.slice(0, 200000)))
      .catch(() => setFailed(true));
  }, [url, file.preview_kind]);

  const wrap = "overflow-hidden rounded-xl border border-slate-200 bg-slate-950";
  if (failed || file.preview_kind === "none") {
    return (
      <div className="flex min-h-[220px] flex-col items-center justify-center gap-3 rounded-xl border border-slate-200 bg-slate-50 p-8 text-slate-400" data-testid="file-preview-generic">
        <FileIcon mime={file.mime_type} ext={file.extension} className="h-14 w-14" />
        <p className="text-xs font-medium uppercase tracking-wider">{file.extension || "file"} · no preview</p>
      </div>
    );
  }
  switch (file.preview_kind) {
    case "image":
      return <div className={`${wrap} flex items-center justify-center`} data-testid="file-preview-image"><img src={url} alt={file.original_filename} className="max-h-[70vh] w-auto max-w-full object-contain" loading="lazy" onError={() => setFailed(true)} /></div>;
    case "video":
      return <div className={wrap} data-testid="file-preview-video"><video src={url} controls playsInline preload="metadata" className="max-h-[70vh] w-full" onError={() => setFailed(true)} /></div>;
    case "audio":
      return <div className="rounded-xl border border-slate-200 bg-slate-50 p-6" data-testid="file-preview-audio"><audio src={url} controls preload="metadata" className="w-full" onError={() => setFailed(true)} /></div>;
    case "pdf":
      return <div className={wrap} data-testid="file-preview-pdf"><iframe title={file.original_filename} src={`${url}#toolbar=0`} className="h-[70vh] w-full bg-white" sandbox="" /></div>;
    case "text":
      return text === null ? <Skeleton className="h-48 w-full" /> : <pre className="max-h-[70vh] overflow-auto rounded-xl border border-slate-200 bg-slate-50 p-4 font-mono text-xs leading-relaxed text-slate-800" data-testid="file-preview-text">{text}</pre>;
    default:
      return null;
  }
}
